import { render, staticRenderFns } from "./AddKeyword.vue?vue&type=template&id=e6696790&"
import script from "./AddKeyword.vue?vue&type=script&lang=ts&"
export * from "./AddKeyword.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./AddKeyword.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mfe-shared/mfe-shared/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6696790')) {
      api.createRecord('e6696790', component.options)
    } else {
      api.reload('e6696790', component.options)
    }
    module.hot.accept("./AddKeyword.vue?vue&type=template&id=e6696790&", function () {
      api.rerender('e6696790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddKeyword.vue"
export default component.exports